import { CommonFormFieldsNames } from 'pages/app-pages/chatbot-builder-page/nodes/components/steps/form-components/types';

export const labelFormFieldConfig = {
  placeholder: 'Add Labels, Type to Create',
  name: CommonFormFieldsNames.Labels,
  type: 'text',
};
